import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";
import { UserCircle2, ImagePlus } from "lucide-react";

export default function Team() {
  const { settings } = useSettings();
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/team").then(r => setTeam(r.data || [])).catch(()=>{}); }, []);

  const aboutImage = settings.brand_image || settings.trucks?.[0] || settings.hero_image;

  return (
    <section id="about" className="section-pad" data-testid="team">
      <div className="mx-auto max-w-7xl px-5 md:px-8 grid lg:grid-cols-2 gap-10 items-center">
        <div className="relative rounded-3xl overflow-hidden ring-1 ring-white/10 aspect-[4/5] max-h-[560px] bg-ink-700">
          {aboutImage ? (
            <img src={aboutImage} alt="AIR-COLD HVAC branded service" className="w-full h-full object-cover"/>
          ) : (
            <div className="w-full h-full grid place-items-center text-silver-500 text-xs uppercase tracking-[0.2em] gap-2 flex-col" data-testid="about-image-placeholder">
              <ImagePlus className="size-7 text-ice-400/70"/> Upload team photo
            </div>
          )}
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.22em] text-ice-400">About Us</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-black">Local techs. Premium standards.</h2>
          <p className="mt-4 text-silver-300">
            AIR-COLD HVAC is a Southern California HVAC company built on three promises: fast response, honest pricing, and quality installs that last. Our team is factory-trained, licensed, and background-checked.
          </p>
          <div className="mt-6 grid grid-cols-2 gap-3">
            {(team.length ? team : [{name:"Owner — Placeholder", role:"Founder"},{name:"Lead Technician", role:"Service"}]).map((m, i) => (
              <div key={m.id||i} className="card-ink rounded-2xl p-4 flex items-center gap-3" data-testid={`team-${i}`}>
                {m.photo ? <img src={m.photo} className="size-12 rounded-full object-cover" alt={m.name}/> : <UserCircle2 className="size-12 text-silver-500"/>}
                <div>
                  <div className="font-semibold text-sm">{m.name}</div>
                  <div className="text-xs text-silver-400">{m.role}</div>
                </div>
              </div>
            ))}
          </div>
          <p className="mt-4 text-xs text-silver-500">Owner can add real team photos from the admin dashboard → Team.</p>
        </div>
      </div>
    </section>
  );
}
